(function () {
  var banner = document.getElementById('dc-top-banner');
  if (!banner) return;

  var CLOSED_KEY = 'dc_top_banner_closed';
  try {
    if (sessionStorage.getItem(CLOSED_KEY) === '1') {
      banner.hidden = true;
      return;
    }
  } catch (e) {}

  var msgs = banner.querySelectorAll('[data-banner-msg]');
  var ROTATE_MS = 4500;
  var i = 0;
  var timer = null;

  function next() {
    msgs[i].classList.remove('is-active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-active');
  }
  function start() {
    if (msgs.length > 1 && !timer) timer = setInterval(next, ROTATE_MS);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }
  start();
  banner.addEventListener('mouseenter', stop);
  banner.addEventListener('mouseleave', start);
  banner.addEventListener('focusin', stop);
  banner.addEventListener('focusout', start);

  var closeBtn = banner.querySelector('[data-banner-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      stop();
      banner.hidden = true;
      try { sessionStorage.setItem(CLOSED_KEY, '1'); } catch (e) {}
    });
  }

  var signupLink = banner.querySelector('[data-action="signup"]');
  if (signupLink) {
    signupLink.addEventListener('click', function (e) {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('dc:open-launch-promo'));
    });
  }
})();
